export const fontFamily = '-apple-system, "proxima-nova", BlinkMacSystemFont, "Segoe UI"';
